
AssignUserController.$inject = ['$scope', '$mdDialog', '$translate', 'assignableUsers'];
export function AssignUserController($scope, $mdDialog, $translate, assignableUsers) {

  $scope.ok = ok;
  $scope.cancel = cancel;
    

  init();

  function ok() {
    $mdDialog.hide($scope.assignedUsers);
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function init() {
    $scope.assignedUsers = {};
    $scope.assignableUsers = assignableUsers;
    $scope.assignableUsers.forEach(user => user.label = user.name + ' (<' + user.email + '>)');

    $scope.usersLabel = $translate.instant('menu/admin/users');
  }
}
